import {h, Fragment} from "preact"
import { useActions } from '@nosto/preact'
import { useState, useEffect } from 'preact/hooks'
import { desktopExpandedFacets, customFacets } from '../config'

export default ({ combinedFacet }) => {
    const { toggleProductFilter } = useActions();
    const [ active, setActive ] = useState(false);
    const [ activeFilterNames, setActiveFilterNames ] = useState(null);
    const selectedFiltersCount =
        combinedFacet.facets.reduce((count, f) => {
            return (count + f?.data?.filter((v) => v.selected).length ?? 0)
        }, 0);

    useEffect(() => {
        if(window.innerWidth > 999 && desktopExpandedFacets.includes(combinedFacet.name)) {
            setActive(true)
        }
    }, [])

    useEffect(() => {
        if (selectedFiltersCount > 0) {
            setActive(true);
            const activeValues = combinedFacet.facets.flatMap((facet) => facet?.data?.filter((v) => v.selected).map((filter) => {
                console.log('f', filter)
                const newFacet = customFacets.find(customFacet => customFacet.name === facet.name) || false;
                console.log(newFacet)
                return (newFacet?.custom?.[filter.value]) 
                    ? newFacet.custom[filter.value]
                    : filter.value
            }))
            setActiveFilterNames(activeValues.join(', '));
        } else {
            setActiveFilterNames(null);
        }
    }, [selectedFiltersCount])

    return (
        <div class={`product-facet__filter-item ns-sidebar-dropdown ${active ? 'ns-active' : ''}`}>
            <button class="collapsible-toggle text--strong"
                data-nosto-element="facet"
                aria-controls={`nosto-facet-${combinedFacet.name}`}
                aria-expanded={`${active ? 'true' : 'false'}`}
                onClick={() => { setActive(!active) }}
            >
                {combinedFacet.name}
                {(activeFilterNames !== null) && (
                    <span class="collapsible-toggle__selected-value text--subdued text--small hidden-tablet-and-up">
                        {activeFilterNames}
                    </span>
                )}
                <svg focusable="false" width="12" height="8" class="icon icon--chevron icon--inline  " viewBox="0 0 12 8"><path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="1.2"></path></svg>
            </button>
            <div class="ns-sidebar-submenu" id={`nosto-facet-${combinedFacet.name}`}>
                <div class="ns-facet-value-container">
                    {combinedFacet.facets.map((parentFacet) => {
                        return parentFacet?.data?.map((value, index) => {
                            const newFacet = customFacets.find(customFacet => customFacet.name === parentFacet.name) || false;
                            if(newFacet && newFacet?.custom?.[value.value] === false) return;
                            return <div class="checkbox-container" data-nosto-element="facet-setting">
                                <input type="checkbox"
                                    class="checkbox"
                                    id={`${parentFacet.id}-${index}`}
                                    checked={value.selected}
                                    onChange={(e) => {
                                        e.preventDefault()
                                        toggleProductFilter(
                                            parentFacet.field,
                                            value.value,
                                            !value.selected
                                        )
                                    }}
                                />
                                <label for={`${parentFacet.id}-${index}`}>
                                    {(newFacet.custom?.[value.value]) ? newFacet.custom[value.value] : value.value} 
                                    &thinsp;({value.count})
                                </label>
                            </div>
                            
                        })
                    })}
                </div>
            </div>
        </div>
    )
}
